import React from 'react'
import { WizTableForm, WizJointExhibition } from '../../../common'
const organizationConfig = WizTableForm.Config.organization(this, { apiParams: { state: 1 } })
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
const positionCategoryConfig = WizTableForm.Config.positionCategory()
const userConfig = WizTableForm.Config.user(this, { apiParams: { state: 1 } })

export default (self, other = {}) => {
    let columns = []
    let { type, id } = other
    if (type.indexOf('Org') !== -1) {
        columns = columns.concat([{
            title: 'orgId',
            name: 'orgId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理组织',
            name: 'manageOrgIdList',
            searchItem: {
                ...organizationConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理组织',
            name: 'manageOrgId',
            formItem: {
                ...organizationConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理组织',
                }]
            }
        }, {
            title: '管理组织',
            name: 'orgName',
            tableItem: {}
        },
        {
            title: '管理组织编码',
            name: 'orgCode',
            tableItem: {},
            // formItem: {
            //     disabled: true,
            //     placeholder: ' '
            // }
        }, {
            title: '组织编码',
            name: 'links',
            formItem: {
                type: 'diy',
                links: 'manageOrgId',
                diy: ({ linksValues }) => {
                    let wizJointExhibitionProps = {
                        type: 'org',
                        data: linksValues
                    }
                    return <WizJointExhibition {...wizJointExhibitionProps} />
                }
            }
        }])
    }
    if (type.indexOf('User') !== -1) {
        columns = columns.concat([{
            title: '管理人姓名',
            name: 'fullName',
            tableItem: {}
        }, {
            title: '管理人账号',
            name: 'userName',
            tableItem: {}
        }, {
            title: '管理人姓名',
            name: 'personIdList',
            searchItem: {
                ...userConfig,
                diy: WizTableForm
            }
        }, {
            title: '管理人',
            name: 'personId',
            formItem: {
                ...userConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理人',
                }]
            }
        }])
    }
    if (type.indexOf('PositionCategory') != -1) {
        columns = columns.concat([{
            title: 'positionCategoryId',
            name: 'positionCategoryId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryIdList',
            searchItem: {
                ...positionCategoryConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryId',
            formItem: {
                ...positionCategoryConfig,
                diy: WizTableForm,
                selectType: 'radio',
                rules: [{
                    required: true,
                    message: '请选择管理岗位分类',
                }]
            }
        }, {
            title: '管理岗位分类',
            name: 'positionCategoryName',
            tableItem: {}
        }])
    } else {
        columns = columns.concat([{
            title: 'positionId',
            name: 'positionId',
            formItem: {
                type: 'hidden'
            }
        }, {
            title: '管理岗位',
            name: 'positionIdList',
            searchItem: {
                ...positionConfig,
                diy: WizTableForm,
            }
        }, {
            title: '管理岗位',
            name: 'positionName',
            tableItem: {}
        }, {
          title: '岗位编码',
          name: 'positionCode',
          tableItem: {}
        }])

        if (type.indexOf('SubjectTo') !== -1) {
            const userPositionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1, orgId: id } })
            columns = columns.concat([{
                title: '管理岗位',
                name: 'positionId',
                formItem: {
                    ...userPositionConfig,
                    diy: WizTableForm,
                    selectType: 'radio',
                    type: 'diy',
                    rules: [{
                        required: true,
                        message: '请选择管理岗位',
                    }]
                }
            }
            // , {
            //   title: '岗位编码',
            //   name: 'links',
            //   formItem: {
            //     type: 'diy',
            //     links: 'positionId',
            //     diy: ({ linksValues }) => {
            //       let wizJointExhibitionProps = {
            //         type: 'position',
            //         data: linksValues
            //       }
            //       return <WizJointExhibition {...wizJointExhibitionProps} />
            //     }
            //   }
            //   }
              ])
        } else {

            columns = columns.concat([{
                title: '管理岗位',
                name: 'positionId',
                formItem: {
                    ...positionConfig,
                    diy: WizTableForm,
                    selectType: 'radio',
                    type: 'diy',
                    links: { 'manageOrgId': '管理组织' },
                    linksKeyFormat: { 'manageOrgId': 'orgId' },
                    rules: [{
                        required: true,
                        message: '请选择管理岗位',
                    }]
                }
            }
            // , {
            //   title: '岗位编码',
            //   name: 'links',
            //   formItem: {
            //     type: 'diy',
            //     links: 'positionId',
            //     diy: ({ linksValues }) => {
            //       let wizJointExhibitionProps = {
            //         type: 'position',
            //         data: linksValues
            //       }
            //       return <WizJointExhibition {...wizJointExhibitionProps} />
            //     }
            //   }
            // }
            ])
        }
    }

    columns = columns.concat([{
        title: 'id',
        name: 'id',
        formItem: {
            type: 'hidden'
        }
    },
    {
        title: '状态',
        name: 'state',
        dict: [
            { code: 1, codeName: "有效" },
            { code: 0, codeName: "无效" }
        ],
        searchItem: {
            type: 'select',
        },
        tableItem: {},
        formItem: {
            type: 'radio',
            initialValue: 1
        }
    },
    {
        title: '创建时间',
        name: 'createTime',
        tableItem: {}
    }])
    return columns
}
